import styles from './AllocationInputView.module.css'
import { Button } from '@/components/Button'
import { NumericInput } from '@/components/inputs/NumericInput'
import {
  FormRow,
  FormColumns,
  FormColumn,
  FormGroup,
  Help,
} from '@/components/Form'
import type { ReactNode } from 'react'

export interface AllocationInputViewProps {
  recipientSelect: ReactNode
  recipientError?: string
  isRemovable: boolean
  onRemove: () => unknown
  allocatedAmount: number
  allocatedPercentage: number
  allocatedAmountError?: string
  onAllocatedAmountChange: (amount: number) => unknown
  onAllocatedPercentageChange: (percentage: number) => unknown
  authorizedPartialPayoutAmount: number
  authorizedPartialPayoutPercentage: number
  authorizedPartialPayoutAmountError?: string
  onAuthorizedPartialPayoutAmountChange: (amount: number) => unknown
  onAuthorizedPartialPayoutPercentageChange: (percentage: number) => unknown
}

export function AllocationInputView({
  recipientSelect,
  recipientError,
  isRemovable,
  onRemove,
  allocatedAmount,
  allocatedPercentage,
  allocatedAmountError,
  onAllocatedAmountChange,
  onAllocatedPercentageChange,
  authorizedPartialPayoutAmount,
  authorizedPartialPayoutPercentage,
  authorizedPartialPayoutAmountError,
  onAuthorizedPartialPayoutAmountChange,
  onAuthorizedPartialPayoutPercentageChange,
}: AllocationInputViewProps) {
  return (
    <div className={styles.allocation}>
      <FormRow>
        <FormColumns>
          <FormColumn>
            <FormGroup label="Recipient">
              {recipientSelect}
              <Help error={recipientError} />
            </FormGroup>
          </FormColumn>
          {isRemovable && (
            <div className={styles.removeBtn}>
              <Button
                label="Remove allocation"
                variant="text-destructive"
                onPress={onRemove}
              />
            </div>
          )}
        </FormColumns>
      </FormRow>
      <FormRow>
        <FormColumns>
          <FormColumn>
            <FormGroup label="Amount">
              <NumericInput
                value={allocatedAmount}
                currencyCode="usd"
                mode="draft"
                precision={2}
                onChange={(n) => onAllocatedAmountChange(n ?? 0)}
                status={allocatedAmountError ? 'danger' : 'default'}
              />
              <Help error={allocatedAmountError} />
            </FormGroup>
          </FormColumn>
          <FormColumn>
            <FormGroup label="Percentage of total">
              <NumericInput
                value={allocatedPercentage}
                mode="live"
                onChange={(n) => onAllocatedPercentageChange(n ?? 0)}
                status={allocatedAmountError ? 'danger' : 'default'}
              />
            </FormGroup>
          </FormColumn>
        </FormColumns>
      </FormRow>
      <FormRow>
        <FormColumns>
          <FormColumn>
            <FormGroup label="Authorized partial payout amount">
              <NumericInput
                value={authorizedPartialPayoutAmount}
                currencyCode="usd"
                mode="draft"
                precision={2}
                onChange={(n) => onAuthorizedPartialPayoutAmountChange(n ?? 0)}
                status={
                  authorizedPartialPayoutAmountError ? 'danger' : 'default'
                }
              />
              <Help error={authorizedPartialPayoutAmountError} />
            </FormGroup>
          </FormColumn>
          <FormColumn>
            <FormGroup label="Percentage of allocation">
              <NumericInput
                value={authorizedPartialPayoutPercentage}
                mode="live"
                onChange={(n) =>
                  onAuthorizedPartialPayoutPercentageChange(n ?? 0)
                }
                status={
                  authorizedPartialPayoutAmountError ? 'danger' : 'default'
                }
              />
            </FormGroup>
          </FormColumn>
        </FormColumns>
      </FormRow>
    </div>
  )
}
